import {
    Container,
    Logo,
    Name
} from './styled';

export function PreviewCompany(props) {

    const { company, ...rest } = props;

    return (
        <Container {...rest} >
            <Logo>
                <img
                    src={company?.avatar}
                    alt="logo--"
                />
            </Logo>
            <Name>
                {company?.nome}
            </Name>
        </Container>
    )
}